module.exports = __webpack_public_path__ + "static/media/mutter_museum.56076843.jpg";